import { useCallback, useRef } from "react";
import type { GridReadyEvent, RowClickedEvent } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { globalDefaultColDef } from "@/setup/ag-grid/mesf-theme";
import type { ProductChange } from "../models/ProductChange";
import { useTableData } from "../hooks/useTableData";

interface ProductChangesTableProps {
	productChanges: ProductChange[];
	selectedChange: ProductChange | null;
	onRowSelected: (change: ProductChange | null) => void;
	onDelete: (change: ProductChange) => void;
}

export const ProductChangesTable = ({
	productChanges,
	selectedChange,
	onRowSelected,
	onDelete,
}: ProductChangesTableProps) => {
	const gridRef = useRef<AgGridReact<ProductChange>>(null);
	const { columnDefs } = useTableData({ onDelete });

	const onGridReady = useCallback(
		(_params: GridReadyEvent<ProductChange>) => {},
		[],
	);

	const onRowClicked = useCallback(
		(event: RowClickedEvent<ProductChange>) => {
			if (event.data) {
				onRowSelected(event.data);
			}
		},
		[onRowSelected],
	);

	const getRowId = useCallback((params: { data: ProductChange }) => {
		return params.data.Id?.toString() ?? "";
	}, []);

	return (
		<AgGridReact<ProductChange>
			ref={gridRef}
			rowData={productChanges}
			columnDefs={columnDefs}
			defaultColDef={globalDefaultColDef}
			onGridReady={onGridReady}
			onRowClicked={onRowClicked}
			getRowId={getRowId}
			rowSelection="single"
			suppressRowClickSelection={false}
			suppressContextMenu
			alwaysShowVerticalScroll
			alwaysShowHorizontalScroll
			suppressColumnVirtualisation
			animateRows={false}
			rowHeight={36}
			headerHeight={36}
			groupHeaderHeight={36}
			getRowStyle={(params) => {
				if (selectedChange?.Id === params.data?.Id) {
					return { backgroundColor: "#e3f2fd", color: "inherit" };
				}
				return undefined;
			}}
		/>
	);
};
